export default __webpack_public_path__ + "static/media/close.bb8f986e.svg";